angular
  .module("accordionPrivacy.components", [])
  .component("accordionPrivacy", {
    templateUrl: "ng/components/accordionPrivacy/accordionPrivacy.view.html",
    bindings: {
      appCustomer: "<",
      privacy: "=",
      formaGiuridica: "<",
      idNumber: "<",
      isFinancial: "@",
      onPrivacyOk: "&?",
      onPrivacyNotOk: "&?",
      noDownload: '<',
      titleOnlyAuth: '<',
      model: '<',
      isLo: "<",
      codFisAzColleg: "<",
      cervedDataNeeded: "<",
      snapshot: '<',
      isGestioneFornitori: '<',
      checkAttivazione: '&?',
      vendorManag: "<",
    },
    controllerAs: "accordionPrivacyCtrl",
    controller: function accordionPrivacyController(
      $rootScope,
      $timeout,
      $configService,
      $giuridicVersion,
      $privacyService,
      FileUploader,
      $instantService,
      $simulationService,
      validationService,
      $financialService,
      $download
    ) {
      var self = this;

      self.$giuridicVersion = $giuridicVersion;
      (self.privacy = {
        downloaded: false,
        documentoPrivacyFirmato: {},
        moduleCode: "",
        subscritionDate: null,
        validityEndDate: null,
        listaConsensi: [],
        writeToNsil: false,
        index: null
      }),
        (self.loadingStatus = {
          uploading: false,
          loadingDataFromCerved: false,
          savedDataFromCerved: false,
          loading: false,
          loadingAddressesList: false,
          loadingPfList: false,
          insertingContract: false
        });

      self.$onInit = function () {
        self.noDownload = self.noDownload || false;
        self.titleOnlyAuth = self.titleOnlyAuth || false;
        self.privacy = self.privacy || null;
        self.formaGiuridica = self.formaGiuridica || null;
        self.isDittaIndividuale = self.$giuridicVersion.isDittaIndividuale(self.formaGiuridica)
        self.idNumber = self.idNumber || null;
        self.progresso = 0;
        self.visualProgBar = false;
        self.visualProgBar1 = false;
        self.today = moment().format("DD/MM/YYYY");
        self.codiceFiscaleOk = true;
        if (self.isLo) {
          self.codFiscale = self.codFisAzColleg;
          self.validationObj = {
            documentDate: {
              disabledDays: [0],
              disabledDates: [
                "01-01",
                "06-01",
                "25-04",
                "01-05",
                "02-06",
                "15-08",
                "01-11",
                "08-12",
                "25-12",
                "26-12"
              ]
            }
          }
        } else {
          self.codFiscale = $configService.getUser().identifier;
        }


        if (!self.isGestioneFornitori && self.model && self.model.listaConsensi.length > 0) {
          self.privacy = self.model;
          self.checkPrivacy();
          return;
        }

        if (self.isGestioneFornitori) {
          return;
        } else if (self.isLo && (self.codFiscale == null || self.formaGiuridica == null)) {
          console.log("Skipping call to getPrivacyData this time!!");
          self.hidePrivacyAccordion = true;
        } else {

          self.hidePrivacyAccordion = false;

          $instantService.getPrivacyData(self.codFiscale, self.formaGiuridica)
            .then(function (response) {
              if (self.privacy && self.privacy.listaConsensi.length == response.metadataAppCustomer.privacy.listaConsensi.length) {
                self.checkPrivacy();
                return;
              } else {
                self.privacy = response.metadataAppCustomer.privacy;
              }
              if (!response.success) {
                self.privacy.valid = false;
              }

              self.checkPrivacy();

            })
            .catch(function (error) {
              console.log("errore nelal chiamata al servizio delle domande della privacy", error);
            })
            .finally(function () {
              self.checkPrivacy();
            });

        }




        if (self.isFinancial) {
          $privacyService
            .getPrivacyData(self.appCustomer)
            .then(function (response) {
              console.log("accordionPrivacy - then.response", response);
              if (response.success) {
                self.privacy = response.appCustomerUser.metadata.privacy;
              }
            })
            .catch(function (error) {
              console.log("accordionPrivacy - catch.response", error);
            })
            .finally(function () {
              self.isLoading = false;
              self.checkPrivacy();
            });
        }

        self.checkPrivacy();
      };

      self.uploadDataFunc = function (item, index, privacy) {
        var document =
          arguments.length > 3 && arguments[3] !== undefined ?
            arguments[3] :
            false;
        if (item) {
          self.uploadData = item;
        }
        self.isPrivacyUpload = privacy;
        self.uploadDocumenti = document;
        self.currentCodeTypeNameIndex = index;
      };

      self.uploader = new FileUploader({
        url: "",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
          "App-Name": $rootScope.portalName
        }
      });

      self.finalUpload = function (item) {
        console.log("calling finalUpload");
        self.folderPath = "" + new Date().getTime();
        var url;
        if (self.isPrivacyUpload && self.isLo) {
          if (self.isGestioneFornitori) {
            url =
              $configService.getAppConfig().url +
              "/simulator/upload/vendorManagement/service-infos/" +
              encodeURIComponent(self.appCustomer.metadata.riUserG.ndg) +
              "/PRIVACY/?token=" +
              $configService.getToken();
          } else {
            url =
              $configService.getAppConfig().url +
              "/simulator/upload/service-infos/" +
              encodeURIComponent(self.idNumber) +
              "/PRIVACY/?token=" +
              $configService.getToken();
          }
        } else if (self.isPrivacyUpload && !self.isLo) {
          url =
            $configService.getAppConfig().url +
            "/simulator/upload/service-infos/" +
            encodeURIComponent(self.idNumber) +
            "/PRIVACY/";
        } else if (!self.isPrivacyUpload) {
          url =
            $configService.getAppConfig().url +
            "/simulator/upload/vendorManagement/service-infos/" +
            encodeURIComponent(self.appCustomer.metadata.riUserG.ndg) +
            "/920/?token=" +
            $configService.getToken();
        } else {
          url =
            $configService.getAppConfig().url +
            "/simulator/upload/service-infos/" +
            encodeURIComponent(self.idNumber) +
            "/" +
            item.code +
            "/";
        }
        for (var int = 0; int < self.uploader.queue.length; int++) {
          self.uploader.queue[int].url = url;
        }
        self.loadingStatus.uploading = true;
        self.uploader.uploadAll();
      };

      self.generateDownloadLink = function (filename, directory) {
        var url = "";
        if (self.isGestioneFornitori) {
          var uuid = directory == 'PRIVACY' ? self.uuidPrivacy || self.model.uuidPrivacy : self.uuidDocRic || self.model.uuidDocRic
          url =
            "/simulator/downloadFromAlbagreen/service-infos/" +
            encodeURIComponent(self.appCustomer.metadata.riUserG.ndg) +
            "/" +
            encodeURIComponent(directory) +
            "/" +
            encodeURIComponent(uuid) + "/"
        } else {
          url =
            "/simulator/download/service-infos/" +
            encodeURIComponent(self.idNumber) +
            "/" +
            encodeURIComponent(directory) +
            "/" +
            encodeURIComponent(filename) + "/"
        }
        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })
      };

      self.generatePrivacyDownloadLink = function (nameFile) {
        self.privacy.downloaded = true;
        var filename = "";
        if (self.$giuridicVersion.isDittaIndividuale(self.formaGiuridica)) {
          filename = "PRIVACY_DIN";
        } else if (self.isGestioneFornitori) {
          filename = "PRIVACY_VENDOR"
        } else {
          filename = "PRIVACY";
        }
        var url = '/uni/download/service-infos/' +
          encodeURIComponent(filename) + '/'

        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })
      };

      self.uploader.onWhenAddingFileFailed = function (
        item /*{File|FileLikeObject}*/,
        filter,
        options
      ) {
        console.info("onWhenAddingFileFailed", item, filter, options);
      };

      self.uploader.onAfterAddingFile = function (fileItem) {
        console.log("fileItem", fileItem);
        if (fileItem.file.size > 26214400) {
          $rootScope.$broadcast("addAlert", {
            text: "MAXIMUM_FILE_SIZE_EXCEEDED"
          });
          fileItem.remove();
          $("#input-upload-" + self.currentCodeTypeNameIndex).val("");
        }
        var fileName = fileItem.file.name;
        if (
          fileName.toLowerCase().indexOf(".pdf") > -1 ||
          fileName.toLowerCase().indexOf(".png") > -1 ||
          fileName.toLowerCase().indexOf(".jpg") > -1 ||
          fileName.toLowerCase().indexOf(".jpeg") > -1 ||
          fileName.toLowerCase().indexOf(".p7m") > -1
        ) {
          if (self.currentCodeTypeNameIndex == 1) {
            self.uploader.queue[0].progress = 100;
            self.visualProgBar1 = true;
            $timeout(function () {
              self.progresso1 = 100;
            }, 50);
            $timeout(function () {
              self.visualProgBar1 = false;
            }, 4000);
            return;
          }
          self.uploader.queue[0].progress = 100;
          self.visualProgBar = true;
          $timeout(function () {
            self.progresso = 100;
          }, 50);
          $timeout(function () {
            self.visualProgBar = false;
          }, 4000);
        } else {
          fileItem.remove();
          $("#input-upload-" + self.currentCodeTypeNameIndex).val("");
          $rootScope.$broadcast("addAlert", {
            text: "FORMAT_NOT_SUPPORTED"
          });
        }
      };

      self.uploader.onAfterAddingAll = function (addedFileItems) {
        console.info("onAfterAddingAll", addedFileItems);
        self.finalUpload(self.uploadData);
      };

      self.uploader.onBeforeUploadItem = function (item) {
        item.file.name = window.encodeURIComponent(item.file.name);
        item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
      };

      self.uploader.onProgressItem = function (fileItem, progress) {
        self.uploadCompleted = false;
      };

      self.uploader.onProgressAll = function (progress) { };

      self.uploader.onSuccessItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        self.loadingStatus.uploading = false;
      };

      self.uploader.onErrorItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        console.info("onErrorItem", fileItem, response, status, headers);
        $rootScope.$broadcast("addAlert", {
          text: "ERROR_UPLOADING_FILE"
        });
        fileItem.remove();
        $("#input-upload-" + self.currentCodeTypeNameIndex).val("");
      };

      self.uploader.onCancelItem = function (
        fileItem,
        response,
        status,
        headers
      ) { };

      self.uploader.onCompleteItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        console.info("onCompleteItem", fileItem, response, status, headers);
        if (response.success) {
          jQuery("#uploadInput_" + self.currentCodeTypeNameIndex).val("");
          console.log(fileItem);
          if (self.isPrivacyUpload) {
            self.privacy.documentoPrivacyFirmato = {
              selected: false,
              nameFile: response.fileName,
            };
            if (self.isGestioneFornitori) {
              self.uuidPrivacy = self.isGestioneFornitori
                ? response.uuid
                : null;
              self.model.uuidPrivacy = self.isGestioneFornitori
                ? response.uuid
                : null;
              self.model.filenamePrivacy = self.isGestioneFornitori
                ? self.privacy.documentoPrivacyFirmato.nameFile
                : null;
            }
          }
        } else if(!response.success && self.isGestioneFornitori) {
          $rootScope.$broadcast("addAlert", {
            text: response.keyMessage,
          });
        }
        self.uploader.queue = [];
        self.checkPrivacy();
      };

      self.uploader.onCompleteAll = function () {
        console.info("onCompleteAll");
        // $timeout(function () {
        //   self.visualProgBar = false;
        // }, 3000);
        self.uploadCompleted = true;
      };

      self.consensiPrivacy = function () {
        self.esito = true;
        if (self.featureService.NewPrivacy()) {
          self.raccoltaInfo.privacy.listaConsensi &&
            self.raccoltaInfo.privacy.listaConsensi
              .filter(function (consenso) {
                return consenso.obbligatorio;
              })
              .forEach(function (consensoObbligatorio) {
                if (
                  consensoObbligatorio.esito == "false" ||
                  consensoObbligatorio.esito == false
                ) {
                  self.esito = false;
                }
              });
        }
        return self.esito;
      };

      self.deletePrivacyDocument = function (doc) {
        if (self.isGestioneFornitori && doc == "documentoPrivacyFirmato") {
          eraseDocumentFromAlbagreen(doc);
          return;
        } else {
          self.progresso = 100;
          self.visualProgBar = true;
          $timeout(function () {
            self.progresso = 0;
          }, 200);
          $timeout(function () {
            self.visualProgBar = false;
          }, 4000);
          var documentRow =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : 0;
          self.privacy.documentoPrivacyFirmato = {};
        }
        self.checkPrivacy();

      };

      var eraseDocumentFromAlbagreen = function (doc) {
        self.progresso = 100;
        self.visualProgBar = true;
        $financialService
          .eraseDocumentFromAlbagreen(
            "soggetto",
            self.appCustomer.metadata.riUserG.ndg,
            self.model.uuidPrivacy
          )
          .then(function (response) {
            if (response.success) {
              self.privacy.documentoPrivacyFirmato = {};
              self.model.filenamePrivacy = null;
            }
            $timeout(function () {
              self.progresso = 0;
            }, 200);
            $timeout(function () {
              self.visualProgBar = false;
            }, 4000);
            self.checkPrivacy();
          })
          .catch(function (error) {
            $timeout(function () {
              self.progresso = 0;
            }, 200);
            $timeout(function () {
              self.visualProgBar = false;
            }, 4000);
            console.log("ERROR: ", error);
          });
      };

      self.check = function (el) {
        el.selected = !el.selected;
      };

      self.checkPrivacy = function () {
        if (!self.privacy) {
          return;
        }

        var diffDate = moment
          .duration(
            moment(self.privacy.validFrom, "DD/MM/YYYY").diff(
              moment(self.today, "DD/MM/YYYY")
            )
          )
          .asDays();

        if (self.privacy.validFrom && diffDate == 0) {
          self.privacy.writeToNsil = false;
        }

        if (!self.isFinancial && self.isGestioneFornitori) {
          var ok =
            ((self.privacy.documentoPrivacyFirmato &&
              self.privacy.documentoPrivacyFirmato.nameFile) ||
              self.model.filenamePrivacy) &&
            !!self.privacy.dataSottoscrizione;
        } else if (!self.isFinancial && !self.isGestioneFornitori) {
          !!self.privacy.dataSottoscrizione &&
            self.privacy.documentPrivacyDownloaded &&
            self.privacy &&
            self.privacy.listaConsensi &&
            self.privacy.listaConsensi
              .filter(function (consenso) {
                return !!consenso.obbligatorio;
              })
              .every(function (consensoObbligatorio) {
                return consensoObbligatorio.esito === true;
              }) &&
            self.privacy.documentoPrivacyFirmato &&
            self.privacy.documentoPrivacyFirmato.nameFile;
        } else {
          var ok =
            self.privacy &&
            self.privacy.listaConsensi
              .filter(function (consenso) {
                return !!consenso.obbligatorio;
              })
              .every(function (consensoObbligatorio) {
                return consensoObbligatorio.esito === true;
              }) &&
            self.privacy.documentoPrivacyFirmato &&
            self.privacy.documentoPrivacyFirmato.nameFile;
        }
        if (ok) {
          self.enableButton = true;
          self.onPrivacyOk &&
            self.onPrivacyOk({
              privacy: self.privacy,
            });
        } else {
          self.enableButton = false;
          self.onPrivacyNotOk && self.onPrivacyNotOk();
        }
      };

      self.generateLinkForPrivacy = function () {
        self.privacy.documentPrivacyDownloaded = true;
        var filename = ""
        if (self.$giuridicVersion.isDittaIndividuale(self.formaGiuridica)) {
          filename = 'PRIVACY_DIN';
        } else {
          filename = 'PRIVACY';
        }

        var url = '/uni/download/service-infos/' +
          encodeURIComponent(filename) + '/'

        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })


      }

      self.downloadPrivacy = function () {
        self.privacy.documentPrivacyDownloaded = true;
        self.checkPrivacy();
      }

      self.savePrivacy = function () {
        self.runSavePrivacy = true;
        self.appCustomer.metadata.privacy = self.privacy;
        $simulationService.inserimentoPrivacy(self.appCustomer)
          .then(function (response) {
            if (response.success) {
              $rootScope.$broadcast("addAlert", {
                text: "INSER_PRV_CLI_OK",
              });
              self.privacy.valid = true;
              self.privacy.dataConferma = response.user.metadata.privacy.dataConferma
              self.privacy.utente = response.user.metadata.privacy.utente
              self.privacy.verificato = response.user.metadata.privacy.verificato
              self.checkAttivazione && self.checkAttivazione()
            }
            self.runSavePrivacy = false;
          })
          .catch(function (error) {
            console.log(error);
            self.runSavePrivacy = false;
          })
      }

    }
  });